import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import Header from './component/Header'
import Footer from './component/Footer'
import { LANG_CONFIG, getInitLang } from './config/lang.config'
import { getHomeConfig, loadNewsDetail } from './config/api'

import '../../common/util/polyfill'
import './style/common.scss'
import './style/news.scss'

function DetailApp() {
  const [lang, setLang] = useState(getInitLang())
  const config = LANG_CONFIG[lang]

  const [newsId, setNewsId] = useState(null)
  const [detail, setDetail] = useState({})
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [homeConfig, setHomeConfig] = useState({})

  const handleSwitchLang = target => {
    if (target === lang) return
    setLang(target)
    const url = target === 'en' ? `?id=${newsId}&lang=en` : `?id=${newsId}`
    window.history.replaceState(null, '', url)
  }

  const handleNavClick = index => {
    const isEn = lang === 'en'
    const sectionHashes = ['#home', '#features', '#gallery']
    const hash = sectionHashes[index] || ''
    window.location.href = (isEn ? './?lang=en' : './') + hash
  }

  const formatDate = val => (val ? String(val).split(' ')[0] : '')

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const id = params.get('id') || '1'
    setNewsId(id)

    setLoading(true)
    setError('')

    loadNewsDetail(id)
      .then(res => {
        const { code, data, msg } = res.data || {}
        if (code === 0 && data) {
          setDetail(data || {})
        } else {
          setError(msg || 'Failed to load news')
          setDetail({})
        }
      })
      .catch(() => {
        setError('Failed to load news')
        setDetail({})
      })
      .finally(() => {
        setLoading(false)
      })

    getHomeConfig(config.apiHome)
      .then(res => {
        const { data = [], code } = res.data || {}
        if (code === 0) {
          const { data: list } = data || {}
          if (list?.length) {
            setHomeConfig(list[0]?.content || {})
          }
        }
      })
      .catch(() => {})
  }, [lang, newsId])

  useEffect(() => {
    if (detail && detail.title) {
      document.title = `${detail.title} - ${config.title}`
    } else {
      document.title = config.title
    }
    const kw = document.getElementById('meta-keywords')
    const desc = document.getElementById('meta-description')
    if (kw) kw.setAttribute('content', config.keywords)
    if (desc) desc.setAttribute('content', config.description)
  }, [detail, config])

  return (
    <div id="app" data-lang={lang}>
      <Header
        lang={lang}
        config={config}
        homeConfig={homeConfig}
        pageIndex={-1}
        onNavClick={handleNavClick}
        onSwitchLang={handleSwitchLang}
      />

      <main className="main-content">
        <section className="news-top-banner">
          <img src={config.newsBanner} alt={config.newsTitle} />
        </section>

        {detail && detail.id ? (
          <nav className="breadcrumb">
            <span>{config.posLabel}</span>
            <a href={lang === 'en' ? './?lang=en' : './'}>
              {config.posHome}
            </a>
            <span> &gt; </span>
            <a href={`./news${lang === 'en' ? '?lang=en' : ''}`}>
              {config.posNews}
            </a>
            <span> &gt; </span>
            <span>{config.posDetail}</span>
          </nav>
        ) : null}

        {detail && detail.id ? (
          <article className="detail-container">
            <header className="detail-header-block">
              <div className="detail-title-line">
                <span className="detail-cat-badge">{detail.template_name}</span>
                <h1 className="detail-title">{detail.title}</h1>
              </div>
              <time className="detail-date" dateTime={detail.publish_at}>
                {formatDate(detail.publish_at)}
              </time>
            </header>

            <hr className="detail-divider" />

            <section
              className="detail-body"
              dangerouslySetInnerHTML={{ __html: detail.content }}
            />

            {detail.video ? (
              <section className="detail-video-wrapper">
                <video src={detail.video} controls preload="auto" />
              </section>
            ) : null}
          </article>
        ) : (
          <div style={{ textAlign: 'center', color: '#8c8375', padding: '100px 0' }}>
            {loading ? 'Loading...' : error || 'Failed to load news'}
          </div>
        )}
      </main>

      <Footer config={config} showToggleBtn={false} />
    </div>
  )
}

ReactDOM.render(<DetailApp />, document.getElementById('app'))
